import { render } from "./SectionPartners.vue?vue&type=template&id=22563bf4"
import script from "./SectionPartners.vue?vue&type=script&lang=js"
export * from "./SectionPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__